import React from 'react';
import {
    Accordion,
    AccordionContent,
    AccordionItem,
    AccordionTrigger,
} from './ui/accordion';

export const FaqAccordion = ({ faqs, testId = 'faq-accordion' }) => (
    <Accordion
        type="single"
        collapsible
        className="border-t border-brand-hairline"
        data-testid={testId}
    >
        {faqs.map((f, i) => (
            <AccordionItem
                key={f.q}
                value={`faq-${i}`}
                className="border-b border-brand-hairline"
            >
                <AccordionTrigger
                    data-testid={`faq-trigger-${i}`}
                    className="py-6 text-left font-display text-base font-bold uppercase tracking-tight text-brand-text hover:text-brand-gold hover:no-underline data-[state=open]:text-brand-gold"
                >
                    {f.q}
                </AccordionTrigger>
                <AccordionContent className="pb-6 font-sans text-base leading-relaxed text-brand-muted">
                    {f.a}
                </AccordionContent>
            </AccordionItem>
        ))}
    </Accordion>
);

export default FaqAccordion;
